module.exports = __webpack_public_path__ + "static/media/icon-deslocamentofds-cinza.6ec50f98.svg";